export const NOTIFICATION_PATH = 'notification/addNotification';
